import styled from 'styled-components';
import { primary, primaryHover, fontSizeSmall } from '../../styles/styled/colors';

export const Tag = styled.button `
    border-radius: 5px;
    display: inline-block;
    margin: 0.4rem 0.2rem 0;
    padding: 0.4rem;
    font-size: ${fontSizeSmall};
    color: #fff;
    text-transform: uppercase;
    background: ${props => !props.active ? primary : primaryHover };
    border: 0;
    &:hover {
        background: ${primaryHover};
        cursor: pointer;
    }
    .fa {
        padding-left: 0.5rem;
    }
`;




// WEBPACK FOOTER //
// ./src/components/DropdownTags/Styled.js